export default __webpack_public_path__ + "static/media/3.df22e1de.jpeg";